import { jsx } from '@amazon/vinyl-tsx'
import { ctx } from '@/util/context'
import { signedIn } from '@/auth/authRef'
import { Icon } from '@/components/Icon'
import { ConnectionStatus } from '@/bridge/CommandBridge'
import { getSearchParams, logDebug } from '@amazon/vinyl-util'
import { getCastingBridge } from './CastingBridge'

export function CastingButton() {
    const { target } = ctx('CastingButton')
    const castingBridge = getCastingBridge()
    return (
        <button
            className="settingsBtn button"
            classList={[
                castingBridge.connectionStatus.map((status) => {
                    return status === ConnectionStatus.CONNECTING ? 'loading' : null
                }),
            ]}
            onclick={() => {
                logDebug(target, 'clicked')
                const status = castingBridge.connectionStatus.value
                if (status === ConnectionStatus.CONNECTING || status === ConnectionStatus.CONNECTED)
                    castingBridge.disconnect()
                else {
                    castingBridge.connect()
                }
            }}
            // Visible when in cast mode (experimental) and isSignedIn data value is true
            visible={getSearchParams().has('castMode') && signedIn()}
        >
            <Icon
                icon={castingBridge.connectionStatus.map((status) => {
                    return status === ConnectionStatus.CONNECTED ? 'castOn' : 'castOff'
                })}
            />
        </button>
    )
}
